import { CustomTextField } from '../../../../../components/CustomTextField';
import CustomDescriptionLabel from './../../../../../components/CustomDescriptionLabel';
import { FILE_TYPE } from '../../../../../Helpers/fileType';
import { size50MB } from '../../../../../constant/variable';
import React from "react";
import CustomPhotoPickerMultiple from '../../../../../components/PhotoPicker/CustomPhotoPickerMultiple';
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 *
 * @param {function} t - Translation function from i18n for translating strings.
 * @param {Array} allEmployees - List of all employees available to select as host.
 * @param {boolean} emptyFields - Flag indicating if required fields are empty (used for validation).
 * @param {boolean} disabled - Determines if the form fields should be disabled.
 * @param {any} photoPickerFile - Current file(s) selected in the photo picker.
 * @param {function} setPhotoPickerFile - Callback to update the photo picker file(s).
 * @param {object} requestAccessItem - Object containing the request details, e.g., `requestReason`.
 * @param {function} handleChange - Function to handle changes in text fields.
 * @param {function} setDisplayModal: Required when used inside a modal
 * @param {boolean} inModalWebCanStream:  Indicates whether the component is being used in a modal; if so, the camera component will be displayed in a separate modal
 */

const RequestAccessForm = ({t,  emptyFields, disabled, photoPickerFile, setPhotoPickerFile,
                               requestAccessItem, handleChange, setDisplayModal, inModalWebCanStream = true}) => {

    return (
        <>
            <div className={"col-12 center-text mt-3"}>
                <CustomDescriptionLabel className='font-color-text-950' trans={t('please_provide_a_reason_for_the_visit_below')}/>
            </div>
            <div className='col-sm-12 col-xxl-12 col-lg-12'>
                <CustomTextField
                    id={'txt_raf_request_reason'}
                    length={512}
                    name={'requestReason'}
                    trans={'description'}
                    value={requestAccessItem.requestReason}
                    type={'text'}
                    disabled={disabled}
                    onChange={handleChange}
                    emptyFields={emptyFields}
                    required={true}
                    multiline={true}
                />
            </div>
            <div className={"col-12 center-text"}>
                <CustomDescriptionLabel trans={t('attach_visitor_documents')}/>
            </div>
            <div className='col-sm-12 col-xxl-12 col-lg-12'>
                <CustomPhotoPickerMultiple
                    id='fp_raf_visitor_document'
                    photoPickerFile={photoPickerFile}
                    setPhotoPickerFile={setPhotoPickerFile}
                    accept={{ ...FILE_TYPE.IMAGE_FILES }}
                    inModal={inModalWebCanStream}
                    setDisplayModal={setDisplayModal}
                    showBtnDeleteItemGallery={true}
                />
            </div>
        </>
    );
};

export default RequestAccessForm;
